

import { useEffect } from "react";
import '../index.css'
export default function CircleCursor() {
  useEffect(() => {
    const cursor = document.getElementById("circle-cursor");

    const move = (e) => {
      if (cursor) {
        cursor.style.left = `${e.clientX}px`;
        cursor.style.top = `${e.clientY}px`;
      }
    };

    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  return <div id="circle-cursor" className="circle-cursor" />;
}
